import AnimationButton from '../AnimationButton/AnimationButton'

type TitleHeaderProps = {
  badgeText: string
  titleLines: string[]
  wrapperClassName?: string
  titleClassName?: string
  badgeWrapperClassName?: string
  badgeClassName?: string
  badgeBorderClassName?: string
}

const TitleHeader = ({
  badgeText,
  titleLines,
  wrapperClassName = '',
  titleClassName = '',
  badgeWrapperClassName = '',
  badgeClassName = '',
  badgeBorderClassName = 'bg-[linear-gradient(90.94deg,#745EF0_0%,rgba(116,94,240,0.1)_50%,#745EF0_100%)]',
}: TitleHeaderProps) => {
  return (
    <div className={`space-y-3 md:mb-5 flex flex-col items-center text-center  ${wrapperClassName}`}>

  <div
    className={`p-[2px] font-rajdhani font-semibold rounded-full w-fit ${badgeBorderClassName} ${badgeWrapperClassName}`}
  >
    <AnimationButton className={badgeClassName}>
      {badgeText}
    </AnimationButton>
  </div>

  <div className={`text-white font-semibold text-xl text-center md:text-3xl  lg:text-5xl lg:space-y-3 ${titleClassName}`}>
    {titleLines.map((line, index) => (
      <p key={`${line}-${index}`}>{line}</p>
    ))}
  </div>

</div>
  )
}

export default TitleHeader
